module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Wi-fi-e194f0d5a2cdf09c21f21a3747da2560.svg";